<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Review IP</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full">
                        <div class="account-body" v-if="publicationIp">
                            <div class="form-field">
                                <strong>Publication:</strong> {{ publicationIp.publication.title }}
                            </div>
                            <div class="form-field">
                                <strong>IP Address:</strong> {{ publicationIp.ip }}
                            </div>
                            <div class="form-field">
                                <strong>Status:</strong> {{ publicationIp.status }}
                            </div>
                            <br/>
                            <div class="results-list">
                                <div class="results-row">
                                    <div class="results-head" data-width="30%">Date</div>
                                    <div class="results-head" data-width="40%">User Agent</div>
                                    <div class="results-head" data-width="30%">Referrer</div>
                                </div>
                                <template v-if="visits.length > 0">
                                    <div class="results-row" v-for="(visit, index) in visits" :key="index">
                                        <div class="results-cell" data-width="30%">{{ visit.view_datetime }}</div>
                                        <div class="results-cell" data-width="40%">{{ visit.view_useragent }}</div>
                                        <div class="results-cell" data-width="30%">{{ visit.view_referrer }}</div>
                                    </div>
                                </template>
                                <div class="results-row" v-if="!visits">
                                    <div class="results-span text-center" data-width="100%">
                                        <p>No recent activity</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="right text-right">
                        <button class="btn-tertiary" type="button" @click="closeView">Close</button>
                        <button class="btn-danger" type="button" @click="handleAction(false)">Reject</button>
                        <button class="btn-primary" type="button" @click="handleAction(true)">Accept</button>
                    </div>
                </div>
            </div>
            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: "PublicationsIpView",
    data() {
        return {
            publicationIp: null,
            visits: null
        }
    },
    mounted() {
        this.setMetaTitle('User Activity | JournoLink Control')
        this.loadData()
    },
    methods: {
        loadData() {
            axios.get(route('publications.ip.show', this.$route.params.publicationIpId))
                .then(response => {
                    this.publicationIp = response.data.publicationIp
                    this.visits = response.data.visits
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        handleAction(action) {
            let path = 'publications.ip.reject'
            if (action) {
                path = 'publications.ip.approve'
            }
            axios.get(
                route(path, this.$route.params.publicationIpId),
                {'action': action}
            ).then(response => {
                this.closeView()
            }).catch(e => {
                console.error({e})
            })
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        }
    }
}
</script>

<style lang="less">
.modal-body {
    h2, h3 {
        text-transform: uppercase;
        font-size: 1.2em;
        letter-spacing: .08em;
        color: #34495e;
        margin-bottom: 10px;
    }
}

p.note {
    margin: 10px 0;
    font-weight: bold;
}
</style>
